/**
 * Catalog product names for the branded med tiers, shared with
 * billing-core / offers. Leaf module (no imports) so any module — including
 * ones inside the plans ↔ medEligibility import cycle — can use these
 * without risking a cycle.
 */
export const BRANDED_SYNC_PRODUCT_NAME = "telehealth-medtier-branded";
export const BRANDED_ASYNC_PRODUCT_NAME = "telehealth-medtier-branded-async";
